// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.pinned-header[data-v-5f0e9643] {\n  position: sticky;\n  z-index: 2;\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n.control-table-title[data-v-5f0e9643] {\n  background-color: var(--v-secondary-lighten1);\n  z-index: 10;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
